import React from 'react';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <section className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-188" data-mp="3kpugtgqsmnhi">
      <div className="mx-auto max-w-5xl" data-id="element-189" data-mp="3ksgwy4rr2bbc">
        <h2 className="text-center font-display text-[1.75rem] font-black leading-tight tracking-tight text-ink sm:text-[2.4rem]" data-id="element-190" data-mp="3fyvxs9ef7bak">
          <span aria-hidden="true" data-id="element-191" data-mp="3b01gxd00jwt3">⭐ </span>Cosa dicono i docenti
        </h2>
        <p className="mt-3 text-center text-sm font-medium text-ink/70" data-id="element-192" data-mp="3700r6w7grz6q">
          <span aria-hidden="true" data-id="element-193" data-mp="3205zwrjs17l5">⭐️⭐️⭐️⭐️⭐️</span> 4.9/5 · +1.200 docenti soddisfatti
        </p>

        <div className="mx-auto mt-10 grid max-w-4xl gap-5 sm:grid-cols-3" data-id="element-194" data-mp="2x0jl4doavja8">
          {testimonials.map(item => <figure key={item.name} className="flex h-full flex-col rounded-2xl bg-sand p-6" data-id="element-195" data-mp="2s2i7i89n8c65">
              <div className="text-sm text-amber-500" aria-label="5 stelle su 5" data-id="element-196" data-mp="v9oojjm9rg2g">
                <span aria-hidden="true" data-id="element-197" data-mp="qall23lxthwl">★ ★ ★ ★ ★</span>
              </div>
              <blockquote className="mt-4 flex-1 font-display text-sm italic leading-relaxed text-ink/85" data-id="element-198" data-mp="q8ivfkop5qse">
                &ldquo;{item.quote}&rdquo;
              </blockquote>
              <figcaption className="mt-6" data-id="element-199" data-mp="m6chhyy4or2p">
                <p className="text-xs font-bold text-ink" data-id="element-200" data-mp="780kfr6ufgb0">{item.name}</p>
                <p className="text-xs text-ink/50" data-id="element-201" data-mp="7a4xozqmtrny">{item.location}</p>
              </figcaption>
            </figure>)}
        </div>

        <p className="mt-8 text-center text-[11px] text-ink/40" data-id="element-202" data-mp="zw674jhgjfdh">
          Testimonianze illustrative a scopo dimostrativo.
        </p>
      </div>
    </section>;
}